module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f0fd98d115c67f4e223492e86cac6e9e.png";